import { z } from 'zod';
import { availableLocales } from '../../i18n/locales';
import reference from '../reference.dto';
import { sort } from '../sort.dto';

export const organizationFilter = z.object({
  organization: reference.array().optional(),
  organizationGroup: reference.array().optional(),
});

export const dateFilter = z.object({
  minDate: z.string().optional(),
  maxDate: z.string().optional(),
});

export const pageFilter = z.object({
  limit: z.coerce.number().default(10).optional(),
  offset: z.coerce.number().default(0).optional(),
});

export const searchFilter = z.object({
  search: z.string().optional(),
});

/**
 * Helper to parse boolean query parameters correctly.
 * Handles both string ('true'/'false') and boolean values from query params.
 */
export const queryBoolean = z
  .union([z.boolean(), z.enum(['true', 'false'])])
  .transform((val) => val === true || val === 'true')
  .optional();

export const listFilter = z.object({
  ...organizationFilter.shape,
  ...dateFilter.shape,
  ...pageFilter.shape,
  ...sort.shape,
});

export const languageFilter = z.object({
  lang: z.enum(availableLocales).optional(),
});

export type ListFilter = z.infer<typeof listFilter>;
